import { Col, Row, Select } from "antd";
import React, { useState, memo } from "react";
import { useLocation } from "react-router-dom";
const CustomFilterSelect = ({ data, getSelectedValues = () => {} }) => {
  const [category, setCategory] = useState([]);
  const [type, setType] = useState([]);
  const [sortData,setSortData]=useState({sort:'',sortBy:''})
  const location = useLocation();

  // Access the state data
  const locationCatId = location?.state?.categoryId !== undefined ? [location?.state?.categoryId] : null;
  const loactionCatName = location?.state?.categoryName || "";
  let load = false;
 
  const defaultValue = locationCatId?.length > 0
    ? { value: locationCatId, label: loactionCatName }
    : null;
    
  const handleChange = (value, name , sort) => {
    console.log(`selected ${value}`);

    if (name === "categories") {
      // console.log(value,"-*-");
      if (!Array.isArray(value) && value !== undefined ) {
        // If not an array, convert it to an array
        value = [value];
      }
      setCategory(value === undefined ? "" : value);
      getSelectedValues({ category: value === undefined ? [] : value, type , sort:sortData?.sort , sortBy:sortData?.sortBy});
    } else if (name === "type") {
      setType(value === undefined ? "" : value);
      getSelectedValues({ category, type: value === undefined ? "" : value , sort:sortData?.sort , sortBy:sortData?.sortBy});
    }
    else if(name === "sort")
    {
      console.log({sort:sort , sortBy: value === undefined ? "" : value })
      setSortData({sort:sort , sortBy: value === undefined ? "" : value })
      getSelectedValues({ category, type , sort:sort , sortBy: value === undefined ? "" : value });
    }
    else if(name === "status")
    {
      getSelectedValues({ category, type , sort:sort , sortBy: value === undefined ? "" : value,status:value === undefined ? "" :value });
    }
  };

  return (
    <div>
      <Row gutter={10}>
        {data &&
          data?.map((ele, index) => (
            <Col key={index} span={6}>
              <Select
                showSearch
                mode={ele?.mode || ""}
                allowClear
                options={ele?.option?.sort((a, b) => a.Label.localeCompare(b.Label)).map((item) => ({
                  value: item?.value,
                  label: item?.Label,
                }))}
                style={{ width: "100%" }}
                placeholder={ele?.placeholder || "Select"}
                className="mt-5"
                onChange={(val) => {
                  handleChange(val, ele?.name , ele?.sort);
                }}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                defaultValue={!ele?.mode && ele?.name == "categories" ? defaultValue : []}
              ></Select>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default memo(CustomFilterSelect);
